import { Modal, Button } from "react-bootstrap";

const DeleteModal = ({
  show,
  onHide,
  onClick,
  label = "Are you sure you want to delete?",
}) => {
  return (
    <Modal
      className="w-100 d-flex justify-content-center align-items-center"
      show={show}
    >
      <div className="w-100 d-flex flex-column justify-content-center align-items-center p-5 gap-10 ">
        <div className="fs-20 fw-600">{label} </div>
        <hr />
        <div className="d-flex gap-20">
          <Button
            onClick={onHide}
            className="border-0"
            style={{ backgroundColor: "#838383" }}
          >
            Cancel
          </Button>
          <Button onClick={onClick} className="px-4">
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
